import React from 'react';
import clsx from 'clsx';

interface ViewerHeaderProps {
    isMinimized: boolean;
    maximizedPosition: 'left' | 'right';
    toggleMaximizedPosition: () => void;
    collapseAll: () => void;
    toggleMinimize: () => void;
    onMouseDown: (e: React.MouseEvent) => void;
    onPopout?: () => void; // new prop
}

/**
 * Header component for the StateViewer
 * @param props - Component props
 * @returns Rendered component
 */
const ViewerHeader: React.FC<ViewerHeaderProps> = ({
    isMinimized,
    maximizedPosition,
    toggleMaximizedPosition,
    collapseAll,
    toggleMinimize,
    onMouseDown,
    onPopout,
}) => {
    return (
        <div
            className={clsx(
                'flex items-center justify-between p-2',
                !isMinimized && 'sticky top-0 z-10 bg-white shadow-xs',
            )}
            onMouseDown={onMouseDown}
        >
            <div className={clsx('font-bold', isMinimized && 'hidden')}>
                Redux State Viewer
            </div>
            <div className="flex gap-2">
                {!isMinimized && (
                    <>
                        <button
                            onClick={toggleMaximizedPosition}
                            className="rounded-sm border border-gray-300 bg-white px-2 py-1 text-xs hover:bg-gray-100"
                            title={`Move to ${
                                maximizedPosition === 'right' ? 'Left' : 'Right'
                            }`}
                        >
                            {maximizedPosition === 'right' ? '⬅️' : '➡️'}
                        </button>

                        <button
                            onClick={collapseAll}
                            className="rounded-sm border border-gray-300 bg-white px-2 py-1 text-xs hover:bg-gray-100"
                            title="Collapse All and Clear Search"
                        >
                            🧹
                        </button>
                        {onPopout && (
                            <button
                                onClick={onPopout}
                                className="rounded-sm border border-gray-300 bg-white px-2 py-1 text-xs hover:bg-gray-100"
                                title="Pop out to new window"
                            >
                                🪟
                            </button>
                        )}
                    </>
                )}
                <button
                    onClick={toggleMinimize}
                    className="rounded-sm border border-gray-300 bg-white px-2 py-1 text-xs hover:bg-gray-100"
                    title={isMinimized ? 'Expand' : 'Minimize'}
                >
                    {isMinimized ? '👀' : '🙈'}
                </button>
            </div>
        </div>
    );
};

export default ViewerHeader;
